module.exports = __webpack_public_path__ + "img/Weapon_136.50b754e8.png";